import { allowedAutographNotes } from "../utils/serialGradeFields";

/** Seletor da nota de autógrafo (mesmo enum do serial comum): "Autentico" | "8" | "9" | "10". */
const AutographNoteSelect = ({ value, onChange, className = "", ariaLabel }) => (
    <select aria-label={ariaLabel} value={value} onChange={(e) => onChange(e.target.value)} className={className}>
        <option value="">Selecione</option>
        {allowedAutographNotes.map((note) => <option key={note} value={note}>{note}</option>)}
    </select>
);

export default AutographNoteSelect;
